module.exports = __webpack_public_path__ + "1cfe7ced6df19e1f1e229ffb9a437ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/pica.jpg
// module id = 1525
// module chunks = 0